import { override } from 'flarum/common/extend';
import DiscussionRenamedPost from 'flarum/forum/components/DiscussionRenamedPost';
/**
 * "X a modifié le titre « ancien » en « nouveau » le …" - the old title in
 * the sentence itself, as phpBB showed it, rather than only in a tooltip on
 * the new one (core's). The words: locale/fr.yml, with no "renommer" -
 * which, on champis.net, means giving a discussion its species.
 */
export default function showOldDiscussionTitle() {
  override(DiscussionRenamedPost.prototype, 'descriptionData', function () {
    // An event post's content: [old, new], not a comment's text.
    const [oldTitle, newTitle] = this.attrs.post.content();
    const data = {
      old: m("strong", {
        className: "DiscussionRenamedPost-old"
      }, oldTitle),
      new: m("strong", {
        className: "DiscussionRenamedPost-new"
      }, newTitle)
    };
    return data;
  });
}